import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { GoogleWorkspaceSensorController } from '../controller/GoogleWorkspaceSensorController';

export class GoogleWorkspaceSensorComponent extends BaseSensorWebComponent {
  public controller!: GoogleWorkspaceSensorController;

  constructor() {
    super();
    this.sensorType = SensorType.GOOGLE_WS;
    this.initialSetup({
      controllerConstructor: GoogleWorkspaceSensorController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
